module.exports = __webpack_public_path__ + "img/book.9cf4ee76.png";